import HoleSelector from './HoleSelector'

export default HoleSelector
